module.exports = __webpack_public_path__ + "media/images/app/homepage/categories/rings-e3c4096e322f5b4570d825cc5ccf8732.webp";